/**
 * ARKO-Chat-Breite (Standalone-Tab): Prozent der nutzbaren Fläche,
 * Viewport-Clamp wie Dokument/Akte-Split. Kein PII im Storage-Key.
 */

export const ARKO_CHAT_WIDTH_STORAGE_PREFIX = 'arkorbit_portal_arko_chat_width_v1__';
export const ARKO_CHAT_WIDTH_LEGACY_KEY = 'portal_arko_chat_width_pct';
export const ARKO_CHAT_WIDTH_DEFAULT_PCT = 100;
export const ARKO_CHAT_WIDTH_MIN_PX = 360;
export const ARKO_CHAT_WIDTH_MIN_PCT = 42;
export const ARKO_CHAT_WIDTH_MAX_PCT = 100;

/**
 * Gemeinsame Spalte für Message-Feed + Composer (Standalone-Chat).
 * Bindet an `.portal-arko-chat-column` — gleiche nutzbare Breite wie
 * „Dokumente dieser Akte“, kein max-w-3xl / 48rem / 1200px Clip.
 * Drag am Pane darf optional enger machen; Default = volle Pane.
 */
export const ARKO_CHAT_COLUMN_CLASS = 'portal-arko-chat-column';

export function arkoChatWidthStorageKey(customerId: string): string {
  const id = customerId.trim() || 'local';
  return `${ARKO_CHAT_WIDTH_STORAGE_PREFIX}${id}`;
}

export function parseArkoChatWidthPct(raw: string | null | undefined): number | null {
  if (raw == null || raw === '') return null;
  const n = Number(raw);
  if (!Number.isFinite(n)) return null;
  return n;
}

/**
 * Clamp der Chat-Spalte: nie breiter als der Container (nichts abgeschnitten),
 * nie schmaler als MIN_PX — außer der Viewport selbst ist enger, dann 100%.
 */
export function clampArkoChatWidthPct(pct: number, containerWidthPx: number): number {
  if (!Number.isFinite(pct)) return ARKO_CHAT_WIDTH_DEFAULT_PCT;
  if (!(containerWidthPx > 0)) {
    return Math.min(
      ARKO_CHAT_WIDTH_MAX_PCT,
      Math.max(ARKO_CHAT_WIDTH_MIN_PCT, pct),
    );
  }
  const minFromPx = (ARKO_CHAT_WIDTH_MIN_PX / containerWidthPx) * 100;
  const minPct = Math.min(ARKO_CHAT_WIDTH_MAX_PCT, Math.max(ARKO_CHAT_WIDTH_MIN_PCT, minFromPx));
  return Math.min(ARKO_CHAT_WIDTH_MAX_PCT, Math.max(minPct, pct));
}
